export const make = (title: string, value?: any, subtitle?: string) => ({
  title,
  value: value || title,
});
